export default __webpack_public_path__ + "Mask-group-10.496a56.svg";